// src/components/Header.js
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineLogin, AiOutlineUser } from "react-icons/ai";
import avatar from "../assets/images/avatar-icon.svg";
import downwardArrow from "../assets/images/downward-arrow.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Header.css";
import basharaat from "../assets/images/BashaaratLogo.svg";

const Header = ({ handleLogin, onProfileClick, hideSidebar = false }) => {

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);   // ✅ reference
  const navigate = useNavigate();

  const admin = React.useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("vendor"));
    } catch {
      return null;
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("vendor");
    localStorage.removeItem("vendorId");
    handleLogin(null);
  };

  /* ✅ CLOSE DROPDOWN WHEN CLICK OUTSIDE */
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, []);

  return (
    <header className="d-flex justify-content-between align-items-center px-4 py-3 shadow-sm header-admin bg-white">

      {/* LOGO */}
      {hideSidebar && (
        <div className="d-flex align-items-center">
          <img
            src={basharaat}
            alt="Logo"
            height="40"
            onClick={() => navigate("/dashboard")}
            style={{ cursor: "pointer" }}
          />
        </div>
      )}

      {/* RIGHT SIDE */}
      <div className="d-flex align-items-center ms-auto">

    <div>
      {!hideSidebar && (
        <button
          className="star-border-button mx-3"
          onClick={() => navigate("/upgrade")}
        >
          <span>Upgrade</span>
        </button>
      )}
    </div>

        {/* ✅ DROPDOWN WRAPPER REF */}
        <div
          ref={dropdownRef}
          className="dropdown position-relative"
          style={{ cursor: "pointer" }}
        >
          <span
            className="fw-bold d-flex align-items-center"
            style={{ fontSize: "24px", gap: "10px" }}
            onClick={() =>
              setDropdownOpen((prev) => !prev)
            }
          >
            <img src={avatar} alt="" width="38" />

            <div>
              {admin?.name || "service provider"}
              <img
                src={downwardArrow}
                width="15"
                className="ms-1"
                alt=""
              />
            </div>
          </span>

          {dropdownOpen && (
            <ul className="dropdown-menu dropdown-menu-end show mt-2">
              <li>
                <button
                  className="dropdown-item d-flex align-items-center"
                  onClick={() => {
                    onProfileClick();
                    setDropdownOpen(false);
                  }}
                >
                  <AiOutlineUser size={18} className="me-2" />
                  Profile
                </button>
              </li>

              <li>
                <button
                  className="dropdown-item d-flex align-items-center"
                  onClick={handleLogout}
                >
                  <AiOutlineLogin size={18} className="me-2" />
                  Sign Out
                </button>
              </li>
            </ul>
          )}
        </div>

      </div>
    </header>
  );
};

export default Header;